import { Client } from '../api';

export default {
    componentWillMount() {
        this.api = new Client();
    },

    componentWillUnmount() {
        this.api.clear();
    },
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/mixins/apiMixin.jsx